import { useSelector } from 'react-redux'
import { faRedo } from '@fortawesome/pro-solid-svg-icons'

import TooltipIconButton from './TooltipIconButton'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const ResetButton = ({ disabled, text, count, onClick }) => {
  const t = useSelector(selectTranslate)

  return (
    <TooltipIconButton
      icon={faRedo}
      text={text}
      disabled={disabled}
      onClick={onClick}
      title={t('common.reset_filters')}
    />
  )
}

export default ResetButton
